module.exports = __webpack_public_path__ + "img/82b60b52cf1c2d0cb6dcb6a10ac84661.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_09.png
// module id = 66
// module chunks = 0